import type { JiraTopBanner } from '@post-office/placement-create-pipeline/pipes';

import { createClientPipeline } from '@post-office/placement-create-pipeline/create-pipeline';

import { type MessageTemplateContext } from '../../..';

import { type JSX } from 'react/jsx-runtime';

export type HydrationResult = { readMoreLink: string };

type Pipe = JiraTopBanner<{
	messageContext: MessageTemplateContext;
	hydrationResult: HydrationResult;
}>;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - Pipe type variance issue with AnyPlacementPipe constraint (JiraTopBanner uses Record<string, never> for PlacementContext)
const clientPipeline = createClientPipeline<Pipe>();

export const createRender: <
	U extends (renderProps: Omit<HydrationResult, 'postOffice'>) => JSX.Element | null,
>(
	render: U,
) => (renderProps: Omit<HydrationResult, 'postOffice'>) => JSX.Element | null =
	clientPipeline.createRender;
